import Icon from '../components/Icon.vue'

Icon.register({"map-o":{"width":2048,"height":1792,"paths":[{"d":"M2020 11q28 20 28 53v1408q0 20-11 36t-29 23l-640 256q-24 11-48 0l-616-246-616 246q-10 5-24 5-19 0-36-11-28-20-28-53v-1408q0-20 11-36t29-23l640-256q24-11 48 0l616 246 616-246q32-13 60 6zM736 146v1270l576 230v-1270zM128 363v1270l544-217v-1270zM1920 1429v-1270l-544 217v1270z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/map-o.js
// module id = 1095
// module chunks = 0